import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import style from './feature-row.module.css';
import { FeatureAvailabilityDisplay } from '../feature-cell/feature-availability-display';
import { FeatureCell } from '../feature-cell/feature-cell';

/**
 * @typedef {import('../../../new-lineup-plan-grid-types.d.ts').Feature} Feature
 */

/**
 * @typedef {import('../../../../../../../../prop-types/subscription-data-types.d.ts').BillingPlan} BillingPlan
 */

/**
 * @param {object} props
 * @param {string} props.currentPlanId
 * @param {Feature} props.feature
 * @param {boolean} props.isLastRow
 * @param {boolean} props.isLastSection
 * @param {string} props.selectedPlanId
 * @returns {React.JSX.Element}
 */
export const FeatureRow = ({ currentPlanId, feature, isLastRow, isLastSection, selectedPlanId }) => {
  return (
    <>
      <FeatureCell
        className={style['feature-name-cell']}
        isLastRowInColumn={isLastRow ? isLastSection : null}
        isLastRowInSection={isLastRow}
      >
        <Text textType={TextType.Paragraph} value={feature.featureNameMessageDescriptor} />
      </FeatureCell>
      {feature.planAvailability.map(({ billingPlanId, isIncludedInPlan }) => {
        return (
          <FeatureCell
            key={`${feature.featureId}:${billingPlanId}`}
            isCurrentPlanColumn={billingPlanId === currentPlanId}
            isLastRowInColumn={isLastRow ? isLastSection : null}
            isLastRowInSection={isLastRow}
            isSelectedPlanColumn={billingPlanId === selectedPlanId}
          >
            <FeatureAvailabilityDisplay isFeatureAvailable={isIncludedInPlan} />
          </FeatureCell>
        );
      })}
    </>
  );
};
